module.exports = __webpack_public_path__ + "img/培训.baf4afb0.png";